export default function GalleryHero() {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/acd503f9076cae41d4134eb85acecda2.jpg"
          alt="Galeria de Projetos"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#010E31]/80 via-[#010E31]/60 to-[#010E31]/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 md:px-6 text-center pt-24">
        <span className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white/90 px-4 py-2 rounded-full text-sm font-medium mb-6">
          <i className="ri-gallery-line"></i>
          Nossos Trabalhos
        </span>
        
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Galeria de
          <span className="block text-[#C0C0C0] mt-2">Projetos Realizados</span>
        </h1>
        
        <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8">
          Explore nossa coleção exclusiva de projetos que combinam design sofisticado, 
          acabamento impecável e a mais alta qualidade em cada detalhe.
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-white/70 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-[#C0C0C0]"></i>
            <span>+500 Projetos</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-[#C0C0C0]"></i>
            <span>15 Anos de Experiência</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-[#C0C0C0]"></i>
            <span>Garantia de Qualidade</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}
